// extracted by mini-css-extract-plugin
export default {"relationship":"FamilyHistorySection_relationship__yY1tc","problem":"FamilyHistorySection_problem__0IpTY"};